import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * converts an object into URL-encoded query string
 * @param {object} o
 * @returns {string} query string
 */
export var stringify = function stringify(o) {
  return Object.entries(o).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return value && key && "".concat(key, "=").concat(encodeURIComponent(value));
  }).join('&');
};

/**
 * Router query params could be an array if the param is in the URL
 * multiple times, we will take the first parameter and use it
 */
export var getStringFromURLParam = function getStringFromURLParam(parameter) {
  if (typeof parameter === 'string') {
    return parameter;
  } else if (Array.isArray(parameter)) {
    return parameter[0];
  }
  return undefined;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/QueryUtils.js
// module id = 3413
// module chunks = 11